const LINKS = [
  { id: "about", label: "About" },
  { id: "practice", label: "Practice" },
  { id: "pricing", label: "Pricing" },
  { id: "contact", label: "Contact" },
];

export const Nav = ({ onNavigate }) => (
  <header
    data-testid="site-nav"
    className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-cream/70 border-b border-olive/10"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
      <button
        data-testid="nav-logo"
        onClick={() => onNavigate("top")}
        className="font-serif uppercase tracking-[0.22em] text-base md:text-lg text-olive hover:opacity-60 transition-opacity duration-300"
      >
        Ophelia Yoga
      </button>
      <nav className="flex items-center gap-5 md:gap-9">
        {LINKS.map((l) => (
          <button
            key={l.id}
            data-testid={`nav-link-${l.id}`}
            onClick={() => onNavigate(l.id)}
            className="link-underline text-xs md:text-sm uppercase tracking-[0.18em] text-olive-soft hover:text-olive transition-colors duration-300"
          >
            {l.label}
          </button>
        ))}
      </nav>
    </div>
  </header>
);
